import React from 'react';

interface DeleteIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const DeleteIcon: React.FC<DeleteIconProps> = ({
  width = 20,
  height = 20,
  className
}) => {
  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-flex'
      }}
      className={className}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width as number}
        height={height as number}
        viewBox="11 0 18 18"
        fill="none"
      >
        <path
          d="M18.2487 15.021C17.8483 15.021 17.5153 14.704 17.5006 14.301L17.2506 7.801C17.234 7.387 17.5573 7.038 17.9703 7.022C17.9811 7.021 17.9909 7.021 18.0006 7.021C18.401 7.021 18.734 7.339 18.7487 7.742L18.9987 14.242C19.0153 14.656 18.692 15.005 18.2789 15.021C18.2682 15.021 18.2584 15.021 18.2487 15.021Z"
          fill="#222222"
        />
        <path
          d="M21.7506 15.021C21.7408 15.021 21.7311 15.021 21.7203 15.021C21.3073 15.005 20.984 14.656 21.0006 14.242L21.2506 7.742C21.2653 7.339 21.5983 7.021 21.9987 7.021C22.0084 7.021 22.0182 7.021 22.0289 7.022C22.442 7.038 22.7653 7.387 22.7487 7.801L22.4987 14.301C22.484 14.704 22.151 15.021 21.7506 15.021Z"
          fill="#292929"
        />
        <path
          d="M27 4H23.5V3.25C23.5 2.01 22.4902 1 21.25 1H18.75C17.5098 1 16.5 2.01 16.5 3.25V4H13C12.5859 4 12.25 4.336 12.25 4.75C12.25 5.164 12.5859 5.5 13 5.5H13.52L13.9424 15.842C13.9902 17.052 14.9785 18 16.1904 18H23.8096C25.0215 18 26.0098 17.052 26.0576 15.842L26.48 5.5H27C27.4141 5.5 27.75 5.164 27.75 4.75C27.75 4.336 27.4141 4 27 4ZM18 3.25C18 2.837 18.3369 2.5 18.75 2.5H21.25C21.6631 2.5 22 2.837 22 3.25V4H18V3.25ZM24.5596 15.781C24.543 16.185 24.2139 16.5 23.8096 16.5H16.1904C15.7861 16.5 15.457 16.185 15.4404 15.781L15.0208 5.5H24.9792L24.5596 15.781Z"
          fill="#292929"
        />
      </svg>
    </span>
  );
};

export default DeleteIcon;
